module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"{bold}","titleBold":"Send your first automated text message","titleDescription":"Get help sending your first automated text message","description":"See helpful tips as you create and send your first automated text message","letsGo":"Let\u0027s go","noThanks":"No thanks"}}')
  delete Component.options._Ctor
}
